import React, { useContext, useEffect, useState } from "react";
import PageHeader from "../Header/PageHeader";
import CustomFolderList from "../Components/CustomFolderList";
import CustomList from "../Components/CustomList";
import { useHistory, useParams } from "react-router-dom";
import SplitView from "../Components/SplitView";
import GridView from "../Components/GridView";
import { DataContext } from "../context/DataContext";
import { ApiCallGateway } from "../Network/apiCallGateway";
import { useQuery } from "@tanstack/react-query";
import { sweetAlert } from "../Utils/SweetAlert";
import {
  addFolderschema,
  sharefolderSchemaObj,
} from "../Validation/FolderValidation";
import { useFormik } from "formik";
import ConfirmModal from "../Components/Modal/ConfirmModal";
import ShareModal from "../Components/Modal/ShareModal";
import AddFolderModal from "../Components/Modal/AddFolderModal";
import PasswordHelper from "../Password/PasswordHelper";
import { sharePWSchemaObj } from "../Validation/PasswordValidation";
import PasswordForm from "../Components/Modal/PasswordForm";
import {
  validationSchema,
  getType,
  upperCase,
  lowerCase,
  numbers,
  symbols,
} from "../Utils/CommonFunction";
function Environment() {
  const {
    // folderDetails,
    isShared,
    setLoader,
    getEnvAccessList,
    adminViewUser,
    setBrudCrumb,
    getFolderAccessList,
  } = useContext(DataContext);
  const history = useHistory();

  const { folderId } = useParams();

  const [tab, setTab] = useState("env");
  const [viewType, setViewType] = useState("list");
  const [shareModal, setShareModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [addFolderModal, setAddFolderModal] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [envId, setEnvId] = useState("");
  const [folderEdit, setFolderEdit] = useState(false);
  const [envDetais, setEnvDetails] = useState({});
  const [pwDetails, setpwDetails] = useState({});

  const [fId, setFId] = useState("");
  const [fDetails, setFdetails] = useState({});
  const [isFolder, setIsFolder] = useState(true);

  const [filename, setFilename] = useState("");
  const [secretFile, setSecretFile] = useState("");
  const [passwordEdit, setPasswordEdit] = useState(false);
  const [passwordLength, setPasswordLength] = useState(8);
  const [uppercaseCheck, setUppercaseCheck] = useState(true);
  const [lowercaseCheck, setLowercaseCheck] = useState(true);
  const [numberCheck, setNumberCheck] = useState(true);
  const [symbolCheck, setSymbolCheck] = useState(true);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [generatePassVisible, setGeneratePassVisible] =
    useState(false);
  const togglePassword = () => setPasswordVisible(!passwordVisible);
  const [passwordType, setPasswordType] = useState("APIs");
  const [passwordModal, setPasswordModal] = useState(false);

  const toggleGeneratePass = () =>
    setGeneratePassVisible(!generatePassVisible);
  const passwordModeltoggle = () => setPasswordModal(!passwordModal);
  const confirmtoggle = () => setConfirmModal(!confirmModal);
  const addFoldertoggle = () => setAddFolderModal(!addFolderModal);
  const sharetoggle = () => setShareModal(!shareModal);

  const { data: folderDetails, refetch: detailsRefetch } = useQuery({
    queryKey: ["folderdetails" + folderId],
    queryFn: async () => {
      const res = await ApiCallGateway.folder.getAFoldersDetails(
        folderId
      );
      if (res?.status === 200) {
        return res?.data[0];
      } else {
        return [];
      }
    },
  });
  const {
    isLoading: passwordLoading,
    data: passwordList,
    refetch: passwordRefetch,
  } = useQuery({
    queryKey: [folderId],
    queryFn: async () => {
      const res = await ApiCallGateway.password.getfolderPasswords(
        folderId,
        adminViewUser?._id || null
      );
      if (res?.status === 200) {
        return res?.data;
      } else {
        return [];
      }
    },
  });

  // console.log(folderDetails);
  const {
    isLoading,
    error,
    data: envList,
    refetch,
  } = useQuery({
    queryKey: ["folderEnvs" + folderDetails?._id],
    queryFn: async () => {
      const res = await ApiCallGateway.folder.getAFoldersEnvs(
        folderDetails?._id
      );
      if (res?.status === 200) {
        return res?.data;
      } else {
        return [];
      }
    },
  });
  const folderFormik = useFormik({
    initialValues: {
      name: folderEdit
        ? isFolder
          ? fDetails?.name
          : envDetais?.name
        : "",
      description: folderEdit
        ? isFolder
          ? fDetails?.description
          : envDetais?.description
        : "",
      color: folderEdit
        ? isFolder
          ? fDetails?.color
          : envDetais?.color
        : "",
    },
    validationSchema: addFolderschema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      console.log({ ...values, shareWith: selectedUsers });
      let res;
      if (folderEdit) {
        console.log(isShared, envDetais);
        res = await ApiCallGateway.folder.updateFolderEnv(
          values,
          envDetais?.envId
            ? envDetais?.envId
            : isFolder
            ? fDetails?._id
            : envDetais._id
        );
      } else {
        res = await ApiCallGateway.folder.createFolderEnv(
          {
            ...values,
            shareWith: selectedUsers,
            folderId: folderDetails?._id,
            defaultEnvs: true,
          },
          false
        );
      }
      addFoldertoggle();
      refetch();
      detailsRefetch();
      console.log(res);
    },
  });
  const shareFolderFormik = useFormik({
    initialValues: {
      folderId: "",
      shareWith: [],
      note: "",
    },
    validationSchema: sharefolderSchemaObj,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      let data = [];
      // console.log({ ...values, shareWith: selectedUsers });
      if (isFolder) {
        for (const element of selectedUsers) {
          let a = {
            passwordFolderId: values.folderId,
            shareWith: element?._id,
            sharedEmail: element?.email,
            sharedName: element?.name,
            expiryDate: null,
            note: values.note,
            isNew: !element?._id,
          };
          data.push(a);
        }
      } else {
        for (const element of selectedUsers) {
          let a = {
            envId: values.folderId,
            shareWith: element?._id,
            sharedEmail: element?.email,
            sharedName: element?.name,
            expiryDate: null,
            note: values.note,
            isNew: !element?._id,
          };
          data.push(a);
        }
      }

      // console.log(data, "kkk");
      const res = await ApiCallGateway.folder.shareFolderEnv(
        data,
        true
      );
      // console.log(res);
      sharetoggle();
      resetForm();
      refetch();
      detailsRefetch();
    },
  });
  const sharePasswordFormik = useFormik({
    initialValues: {
      passwordId: "",
      shareWith: [],
      expiryDate: "",
      permissionType: "",
      note: "",
    },
    validationSchema: sharePWSchemaObj,
    onSubmit: async (values, { resetForm }) => {
      let data = [];
      // console.log({ ...values, shareWith: selectedUsers });
      for (const element of selectedUsers) {
        let a = {
          passwordId: values.passwordId,
          shareWith: element?._id,
          sharedEmail: element?.name,
          expiryDate: values.expiryDate,
          permissionType: values.permissionType,
          note: values.note,
        };
        data.push(a);
      }
      // console.log(data);
      const res = await ApiCallGateway.password.sharePassword(data);
      // console.log(res);
      resetForm();
    },
  });

  const passwordFormik = useFormik({
    initialValues: validationSchema(
      passwordType,
      pwDetails,
      passwordEdit
    ).initial,
    validationSchema: validationSchema(
      passwordType,
      pwDetails,
      passwordEdit
    ).schma,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      let pwExpiryDate = values?.pwExpiryDate;

      delete values?.pwExpiryDate;

      values = {
        ...values,
        pwExpiryDate: pwExpiryDate ? pwExpiryDate : null,
      };
      let res;
      if (passwordEdit) {
        // console.log(JSON.stringify(values), pwDetails?._id);
        if (
          values?.password === "XXXXXXXXXXXXX" ||
          values?.apiSecret === "XXXXXXXXXXXXX"
        ) {
          delete values?.apiSecret;
          delete values?.password;
        }
        if (
          values?.passwordType === "APIs" ||
          values?.passwordType === "Cloud Services"
        ) {
          if (secretFile)
            values = {
              ...values,
              filename: filename,
              secretFile: secretFile,
            };
        }
        res = await ApiCallGateway.password.updatePassword(
          JSON.stringify(values),
          pwDetails?._id
        );
        passwordModeltoggle();
        setPasswordEdit(false);
      } else {
        if (
          values?.passwordType === "APIs" ||
          values?.passwordType === "Cloud Services"
        ) {
          if (secretFile)
            values = {
              ...values,
              filename: filename,
              secretFile: secretFile,
            };
        }
        values = {
          ...values,
          folderId: folderDetails?._id,
        };
        res = await ApiCallGateway.password.createPassword(
          JSON.stringify(values)
        );
        passwordModeltoggle();
      }

      // console.log(res);
      passwordRefetch();
      resetForm();
    },
  });

  useEffect(() => {
    if (generatePassVisible)
      generatePassword(
        uppercaseCheck,
        lowercaseCheck,
        numberCheck,
        symbolCheck
      );
  }, [
    symbolCheck,
    uppercaseCheck,
    numberCheck,
    lowercaseCheck,
    passwordLength,
    generatePassVisible,
  ]);

  // console.log(passwordList);

  const isOpChecked = (param) => {
    let pw;
    if (param === "numbers") {
      pw = numbers();
      return { isChecked: numberCheck, pwGen: pw };
    }
    if (param === "upperCase") {
      pw = upperCase();
      return { isChecked: uppercaseCheck, pwGen: pw };
    }
    if (param === "symbols") {
      pw = symbols();
      return { isChecked: symbolCheck, pwGen: pw };
    }
    if (param === "lowerCase") {
      pw = lowerCase();
      return { isChecked: lowercaseCheck, pwGen: pw };
    }
  };

  async function generatePassword(
    uppercaseCheck,
    lowercaseCheck,
    numberCheck,
    symbolCheck
  ) {
    const symbols = symbolCheck ? 1 : 0;
    const numbers = numberCheck ? 1 : 0;
    const lowercase = lowercaseCheck ? 1 : 0;
    const uppercase = uppercaseCheck ? 1 : 0;
    if (numbers + symbols + uppercase + lowercase === 0) {
      return sweetAlert(
        "Oops!",
        "No box chosen. Please select at least one box!",
        "error"
      );
    }

    let pw = "";

    while (pw.length < passwordLength) {
      let num = Math.floor(Math.random() * getType.length);
      let typeAdder = getType[num];
      let status = isOpChecked(typeAdder);
      if (status?.isChecked) {
        pw += status?.pwGen;
      }
    }
    // setPassword(pw);
    passwordFormik.setFieldValue("password", pw);

    // onGeneratePw(pw);
  }
  async function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
      setSecretFile(file);
      setFilename(file?.name);
    });
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    console.log(file);
    try {
      const base64String = await getBase64(file);
      setFilename(file?.name);

      setSecretFile(base64String);
    } catch (error) {
      console.error(error);
    }
  };
  const handleSelectUsers = (user) => {
    if (!selectedUsers.includes(user)) {
      setSelectedUsers((oldValue) => [...oldValue, user]);
    }
  };

  const removeSelectUsers = (user) => {
    if (selectedUsers.includes(user)) {
      setSelectedUsers(selectedUsers.filter((u) => u !== user));
    }
  };

  const deleteFolder = async (id) => {
    setLoader(true);
    const res = await ApiCallGateway.folder.deleteFolderEnv(id);
    console.log(res);
    if (res?.status === 200) {
      confirmtoggle();
      refetch();
      setLoader(false);
    }
    setLoader(false);
    if (isFolder) {
      history.goBack();
    }
  };

  useEffect(() => {
    // if (!folderDetails?._id) {
    //   history.push("/folder_project");
    // }
    refetch();
  }, [folderDetails?._id]);
  return (
    <div>
      <PageHeader
        title={folderDetails?.name}
        importCSV={false}
        folder_details={true}
        folderData={folderDetails}
        back={true}
        createEnv={true}
        tab={false}
        isback={true}
        leftHeader={false}
        pwTabNR={true}
        setTab={(e) => setTab(e)}
        viewType={viewType}
        setViewType={(e) => setViewType(e)}
        splitIcon={tab === "pass" ? true : false}
        addFoldertoggle={() => {
          addFoldertoggle();
          setFolderEdit(false);
          folderFormik.resetForm();
          setSelectedUsers([]);
        }}
        shareFoldertoggle={(item) => {
          sharetoggle();
          setFId(item._id);
          setIsFolder(true);
          getFolderAccessList(item._id);
          shareFolderFormik.setFieldValue("folderId", item._id);
        }}
        confirmFoldertoggle={(item) => {
          confirmtoggle();
          setIsFolder(true);
          setFdetails(item);
          setFId(item?._id);
        }}
        editFoldertoggle={(details) => {
          // console.log(details);
          setFId(details?._id);
          setIsFolder(true);
          setFdetails(details);
          setFolderEdit(true);
          addFoldertoggle();
        }}
      />
      {tab === "env" && viewType === "list" ? (
        <CustomFolderList
          env_subfolder={true}
          data={envList}
          onItem={(fdetails) => {
            // console.log(fdetails);
            history.push(`/env_passwords/${fdetails?._id}`);
            // setEnvDetails(fdetails);
          }}
          detailstoggle={(details) => {
            history.push(`/env_passwords/${details?._id}`);
            // setFDetails(details);
          }}
          sharetoggle={(item) => {
            // console.log(item);
            sharetoggle();
            setIsFolder(false);
            setEnvId(item._id);
            getEnvAccessList(item._id, item?.folderId);
            shareFolderFormik.setFieldValue("folderId", item._id);
          }}
          edittoggle={(details) => {
            // console.log(details);
            setIsFolder(false);
            setEnvDetails(details);
            setFolderEdit(true);
            addFoldertoggle();
          }}
          confirmtoggle={(id) => {
            confirmtoggle();
            setIsFolder(false);
            setEnvId(id);
          }}
        />
      ) : null}

      {tab === "env" && viewType === "grid" ? (
        <GridView
          env_subfolder={true}
          data={envList}
          onItem={(fdetails) => {
            history.push(`/env_passwords/${fdetails?._id}`);
          }}
        />
      ) : null}
      {/* <PasswordHelper
        passwordList={passwordList}
        viewType={viewType}
        sharePasswordFormik={sharePasswordFormik}
        onRefetch={() => passwordRefetch()}
        isShared={false}
        passwordModeltoggle={() => passwordModeltoggle()}
        passweordDetails={(data) => {
          // console.log(data);
          setpwDetails(data);
          setPasswordType(data?.passwordType);
        }}
        setEditPassword={() => setPasswordEdit(true)}
      /> */}
      {/* {tab === "pass" ? (
        <div style={{ display: "flex", marginTop: 15 }}>
          <CustomList env_subfolder={true} />
          {viewType === "split" ? (
            <div className="split-view-box">
              <SplitView />
            </div>
          ) : null}
        </div>
      ) : null} */}
      <ShareModal
        md={true}
        isEnv={!isFolder}
        isFolder={isFolder}
        shareModal={shareModal}
        shareModaltoggle={sharetoggle}
        formik={shareFolderFormik}
        handleSelectUsers={(user) => handleSelectUsers(user)}
        removeSelectUsers={(id) => removeSelectUsers(id)}
        selectedUsers={selectedUsers}
      />
      <PasswordForm
        isEdit={passwordEdit}
        passwordModaltoggle={() => passwordModeltoggle()}
        passwordModal={passwordModal}
        numberCheck={numberCheck}
        numberChecktoggle={() => setNumberCheck(!numberCheck)}
        uppercaseCheck={uppercaseCheck}
        uppercaseChecktoggle={() =>
          setUppercaseCheck(!uppercaseCheck)
        }
        lowercaseCheck={lowercaseCheck}
        lowercaseChecktoggle={() =>
          setLowercaseCheck(!lowercaseCheck)
        }
        symbolCheck={symbolCheck}
        symbolChecktoggle={() => setSymbolCheck(!symbolCheck)}
        passwordLength={passwordLength}
        setPasswordLength={(e) => setPasswordLength(e)}
        onRefresh={() =>
          generatePassword(
            uppercaseCheck,
            lowercaseCheck,
            numberCheck,
            symbolCheck
          )
        }
        passwordVisible={passwordVisible}
        togglePassword={() => togglePassword()}
        generatePassVisible={generatePassVisible}
        toggleGeneratePass={() => toggleGeneratePass()}
        // passwordValue={password}
        passwordType={passwordType}
        setPasswordType={(e) => setPasswordType(e)}
        formik={passwordFormik}
        handleFileChange={(e) => handleFileChange(e)}
      />
      <AddFolderModal
        title={
          folderEdit ? "Edit Env/Subfolder" : "Add New Env/Subfolder"
        }
        addFolderModal={addFolderModal}
        addFoldertoggle={addFoldertoggle}
        isEdit={folderEdit}
        formik={folderFormik}
        handleSelectUsers={(id) => handleSelectUsers(id)}
        removeSelectUsers={(id) => removeSelectUsers(id)}
        selectedUsers={selectedUsers}
      />
      <ConfirmModal
        confirmModal={confirmModal}
        confirmModaltoggle={confirmtoggle}
        passwordId={isFolder ? fDetails : envId}
        onProceed={(data) => deleteFolder(data?._id)}
      />
    </div>
  );
}

export default Environment;
